import { Check, X } from "lucide-react";

interface IncludesExcludesProps {
  includes: string[];
  excludes: string[];
}

const IncludesExcludes = ({ includes, excludes }: IncludesExcludesProps) => {
  return (
    <section className="max-w-6xl mx-auto px-4">
      <div className="grid md:grid-cols-2 gap-6">
        {/* Qué incluye */}
        <div className="rounded-2xl border border-emerald-200 bg-emerald-50/40 p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-600 flex items-center justify-center">
              <Check className="w-5 h-5" strokeWidth={3} />
            </div>
            <h3 className="text-xl font-bold">Qué incluye</h3>
          </div>
          <ul className="space-y-3">
            {includes.map((item, i) => (
              <li key={i} className="flex items-start gap-3 text-sm">
                <Check
                  size={18}
                  className="text-emerald-600 shrink-0 mt-0.5"
                  strokeWidth={3}
                />
                <span
                  className="text-foreground/90"
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </li>
            ))}
          </ul>
        </div>

        {/* Qué no incluye */}
        <div className="rounded-2xl border border-red-200 bg-red-50/40 p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-xl bg-red-100 text-red-600 flex items-center justify-center">
              <X className="w-5 h-5" strokeWidth={3} />
            </div>
            <h3 className="text-xl font-bold">Qué no incluye</h3>
          </div>
          <ul className="space-y-3">
            {excludes.map((item, i) => (
              <li key={i} className="flex items-start gap-3 text-sm">
                <X
                  size={18}
                  className="text-red-500 shrink-0 mt-0.5"
                  strokeWidth={3}
                />
                <span
                  className="text-foreground/90"
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default IncludesExcludes;
